import { ConfigProvider } from 'antd';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { darkTheme } from 'theme/darkTheme';
import { lightTheme } from 'theme/lightTheme';

type Theme = 'light' | 'dark';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function MaximorThemeProvider({
  defaultTheme,
  children,
}: {
  defaultTheme?: Theme;
  children: React.ReactNode;
}) {
  const [theme, setTheme] = useState<Theme>(() => {
    const savedTheme = localStorage.getItem('theme');
    return defaultTheme || (savedTheme as Theme) || 'light';
    // return defaultTheme || 'light';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add(theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <ConfigProvider
        theme={
          {
            ...(theme === 'light' ? lightTheme : darkTheme),
            cssVar: true,
          } as any
        }
      >
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a MaximorThemeProvider');
  }
  return context;
}
